import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';

@Component({
    selector: 'app-popup-header',
    template: `
    <div
      class="tw-flex tw-flex-row tw-items-center tw-justify-between app-mt2 app-ml2 "
    >
      <h2 md-color="red">
        {{ title | translation: translationRequest }}
      </h2>
      <button
        mat-icon-button
        type="button"
        cdkfocusinitial
        [mat-dialog-close]="true"
        (keydown)="PopupCloseTabOut($event)"
        class=" app-mr2"
      >
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  `,
    styles: [
        `
      .popupheading {
        font: 400 15px/24px Roboto, 'Helvetica Neue', sans-serif !important;
        letter-spacing: normal !important;
        margin: 0 0 16px !important;

        font-size: 20px !important;
        padding-left: 30px !important;
        margin-top: 30px !important;
        margin-bottom: 30px !important;
        padding-bottom: 30px !important;
        border-bottom: 1px solid #eee !important;
      }
    `,
    ],
    standalone: false
})
export class PopupHeaderComponent implements OnInit {
  @Input() headerTitle: string;
  @Output() CloseTabOut: EventEmitter<any> = new EventEmitter();
  title: string;
  
  translationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'Shared',
    subGroup: 'Shared',
  });
  constructor() {}

  ngOnInit(): void {
    this.title = this.headerTitle;
  }

  PopupCloseTabOut(event: any): boolean {
    if (event.keyCode == 9) {
      this.CloseTabOut.emit(true);
      return false;
    }

    return true;
  }
}
